<template>
  <div class="in-modal">
    <modal
      name="reductions"
      transition="nice-modal-fade"
      :min-width="200"
      :min-height="200"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="true"
      :reset="true"
      width="80%"
      height="auto"
    >
      <div class="header">
        <h1>
          {{ $t("message.reductions") }}
          <span>
            <button
            class="btn btn-link"
            style="font-size: 30px;color: white;float: right;padding: 0px;position: relative;bottom: 3px;"
            @click="hide('reductions')"><i class="fa fa-window-close" style="font-size: 38px;"></i></button>
            <button
              style="float: right;margin-right: 20px;width: 44px;font-size: 5px;color: #59bf8d;background: white none repeat scroll 0% 0%;border-radius: 5px;"
              class="btn btn-primary btn-block"
              @click="download('reductions')"
            >
              <i class="fa fa-file-pdf" style="font-size: 22px;"></i><!--&nbsp;&nbsp;pdf-->
            </button>
          </span>
        </h1>
      </div>

      <div class="content row">
        <div class="col-lg-12 col-md-12 col-sm-12 columns">
        <!-- <div v-if="this.$i18n.locale === 'en'">
          <span>List of price reductions on link below:</span>
          <span><a href="http://www.pulsar.pl/ftp/tl/reductions.xlsx">show more</a></span>
        </div>
        <div v-else>
          <span>Lista produktów z obniżonymi cenami dostępna pod linkiem:</span>
          <span><a href="http://www.pulsar.pl/ftp/tl/obnizki.xlsx">zobacz</a></span>
        </div> -->
          <ul v-if="reductions_products_uniq.length" class="lista_produktow">
            <li v-for="product in reductions_products_uniq" :key="product.data.code">
              <button v-scroll-to="{ el: `#`+to_slug(product.data.code), onStart: onStart, }"
              class='btn btn-link'
              style="text-decoration:none; font-size: 16px;padding: 2px; width:100%;text-align: left;">

                <div class="col1"><b>{{product.data.code}}</b> - <span style="font-size: 12px">{{product.data.name}}</span></div>
                <div class="col2"><span style="font-size: 12px;">{{ $t("message.show_product") }}</span></div>
                <div class="col3"><Price :product="product"/></div>

              </button>
            </li>
          </ul>
          <ul v-else>
            <li>{{ $t('message.no_results_reductions') }}</li>
          </ul>
        </div>

      </div>
    </modal>
    <button
      class="btn btn-primary btn-block btnRight"
      @click="show('reductions')"
    >{{ $t("message.reductions") }}</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { helpers } from "../mixins/helpers";
import Price from "../Product/Price.vue";

export default {
  mixins: [helpers],
  components: {
    Price
  },
  methods: {
    show(name) {
      this.$modal.show(name);
    },
    hide(name) {
      this.$modal.hide(name);
    },
    onStart() {
      this.hide("reductions");
    }
  },
  computed: {
     ...mapGetters('pricelist', ['listType', 'products']),
    reductions_products() {
      let productsList = this.products // this.$store.getters["pricelist/products"];
      let typeList = (this.listType == 'mw') ? 'Mean Well' : 'Pulsar'
      return Object.values(productsList).filter(item => {
      // return products.filter(item => {
        return (item.data && item.data.price && item.data.price.reduction && item.data.producer == typeList) ? item.data.price.reduction : null;
      });
    },
    reductions_products_sort() {
      //return this.sales_products;
      return this.reductions_products.sort((a, b) =>
        a.data.code > b.data.code ? 1 : -1
      );
    },
    reductions_products_uniq() {
      var Remove_duplicate_Value = [];
      var obj_products = [];
      for (var i = 0; i < this.reductions_products_sort.length; i++) {
        if (
          Remove_duplicate_Value.indexOf(
            this.reductions_products_sort[i].data.code
          ) === -1
        ) {
          Remove_duplicate_Value.push(
            this.reductions_products_sort[i].data.code
          );
          obj_products.push(this.reductions_products_sort[i]);
        }
      }
      return obj_products;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color: #59bf8d;

.in-modal {
  h1 {
    margin-bottom: 0;
    font-size: 1.4em;
  }
  .content {
    padding: 15px 30px;
    .separator {
      select {
        font-size: 0.8em;
        option {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          padding: 15px 0;
        }
      }
    }
  }
  .header {
    background: @color;
    padding: 15px 30px;
    color: #fff;
  }
  .form-check {
    padding-left: 2.25rem;
    .form-check-label {
      font-size: 0.8em;
    }
  }
  .buttons {
    margin-top: 30px;
    text-align: right;
  }
}

.col2{
  float: inline-end;
  margin-left: 20px;
}
.col3 {
    float: inline-end;
}
.lista_produktow li:hover{
  background: #f2f2f2;
  padding: 0px 5px;
}

.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  background: @color;
  color: #fff;
  border-color: @color;
}
.btn-primary {
  background: @color;
  color: #fff;
  border-color: @color;
  font-weight: 400;
  min-width: 85px;
}
ul {
  font-size: 0.8em;
  padding-left: 15px;
  li {
    margin: 0 0 4px 0;
    div {
      display: inline;
    }
    a {
      cursor: pointer;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
    button {
      font-size: 0.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reductions/Reductions.vue